import { Component } from '@angular/core';
import { IFilterParams} from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import {IOrdersSupportDetails} from "@irb/irb-orders/irb-orders.model";

@Component({ standalone: false,
  selector: 'irb-inventory-custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})

export class CustomFilterComponent  implements IFilterAngularComp {
  params: any;
  orderSupportDetails: IOrdersSupportDetails;
  errorOrdersToolTip = 'Filter the table to show only orders with errors.';
  warningOrdersToolTip = 'Filter the table to show only orders with warnings.';
  heldOrdersToolTip = 'Filter the table to show only orders that are on hold.';

  constructor() {
  }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  doesFilterPass(): boolean {
    return true;
  }

  filterErrorOrders() {
    this.params.api.getColumnFilterInstance('orderStatus').then((f:any) => {
      f.setModel({
        values: ['Error'],
      }).then(() => { f.applyModel(); this.params.api.onFilterChanged() });    
    });
    
  }

  filterWarningOrders() {
    this.params.api.getColumnFilterInstance('orderStatus').then((f:any) => {
        f.setModel({
          values: ['Warning'],
        }).then(() => { f.applyModel(); this.params.api.onFilterChanged() });
    });    
  }

  filterHeldOrders() {
    this.params.api.getColumnFilterInstance('orderStatus').then((f:any) => {
          f.setModel({
          values: ['On hold'],
        }).then(() => { f.applyModel(); this.params.api.onFilterChanged() });
    });
  }

  isFilterActive(): boolean {
    return false;
  }

  getModel(): any {
    return this.orderSupportDetails;
  }

  setModel(model: any): void {
    this.orderSupportDetails = model;
  }
}

